import axiosInstance from '../axiosInstance';

// Obtener todos los tipos de mantenimiento
export const fetchMaintenanceTypes = async () => {
  const response = await axiosInstance.get('/maintenance/types');
  return response.data;
};

// Crear un tipo de mantenimiento
export const createMaintenanceType = async (data) => {
  const response = await axiosInstance.post('/maintenance/types', data);
  return response.data;
};

// Actualizar un tipo de mantenimiento
export const updateMaintenanceType = async (id, data) => {
  const response = await axiosInstance.put(`/maintenance/types/${id}`, data);
  return response.data;
};

// Eliminar un tipo de mantenimiento
export const deleteMaintenanceType = async (id) => {
  const response = await axiosInstance.delete(`/maintenance/types/${id}`);
  return response.data;
};
